import { render } from "./OverlayPopup.vue?vue&type=template&id=7ef87598&scoped=true"
import script from "./OverlayPopup.vue?vue&type=script&lang=js"
export * from "./OverlayPopup.vue?vue&type=script&lang=js"

import "./OverlayPopup.vue?vue&type=style&index=0&id=7ef87598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef87598"]])

export default __exports__